interface SpinnerProps {
  label?: string;
  size?: number;
}

/** Indicador de carga con una pieza girando: discreto y temático. */
export function Spinner({ label, size = 28 }: SpinnerProps) {
  return (
    <div className="flex flex-col items-center gap-3" role="status" aria-live="polite">
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        className="animate-spin"
        style={{ animationDuration: '900ms' }}
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" stroke="var(--color-border-strong)" strokeWidth="2.5" />
        <path
          d="M12 2a10 10 0 0 1 10 10"
          stroke="var(--color-brand-strong)"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      {label ? <span className="text-sm text-muted">{label}</span> : null}
      <span className="sr-only">Cargando</span>
    </div>
  );
}
